.flag-address-button {
  white-space: nowrap;
}

.flag-address-button-wrapper {
  width: fit-content;
}
